import React, { useState } from "react";
import CustomModal from "../UI/CustomModal";
import cs from "classnames";
import CustomInput from "../UI/CustomInput";
import CustomButton from "../UI/CustomButton/inedx";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import { editCalculatorSelector } from "../../redux/selectors/CalculatorSelectors";
import { themModeSelector } from "../../redux/selectors/AuthSelectors";
import { getParameterByName } from "./helper";
import { useHistory, useParams } from "react-router-dom";
import EtsyLogo from "../../assets/Etsy_logo.svg.png";
import PoshmarkLogo from "../../assets/Poshmark_logo.png";
import depopLogo from "../../assets/depop-logo-vector.png";
import ShopifyLogo from "../../assets/Shopify_logo_2018.svg.png";
import stockxLogo from "../../assets/stockx.png";
import MercariLogo from "../../assets/Mercari_logo_2018.svg.png";
import GOATLogo from "../../assets/GOAT-Logo.png";
import vintedLogo from "../../assets/vinted-marketplace-logo.png";
import Grailed from "../../assets/Grailed.png";
import offerupLogo from "../../assets/offerup.png";
import FacebookLogo from "../../assets/Facebook-f_Logo-Blue-Logo.wine.svg";
import useWindowSize from "../../hooks/useWindowSize";
import { showMobileHeaderModal } from "../../redux/actions/CalculatorAction";

const CalculationSavedModal = ({
  isCalculate,
  setIsCalculate,
  calculatorType,
  calculationSave,
  isStep5,
  data,
  setData,
  handleBlur,
  handleSaveCalculation,
}) => {
  const dispatch = useDispatch();
  const saveCalculatorData = useSelector(editCalculatorSelector);
  const { isDarkMode } = useSelector(themModeSelector);
  const calcId = getParameterByName("id");
  const history = useHistory();
  const { location } = history as any;
  const params = useParams<any>();
  const { width } = useWindowSize();
  const [showCompareList, setShowCompareList] = useState(width > 600);
  const handlePageBack = () => {
    history.push(`/stream/${params?.name}`);
  };

  const renderPlatformLogo = (type) => {
    switch (type) {
      case "etsy":
        return (
          <img src={EtsyLogo} alt={"PlatformLogo"} className="platformLogo" />
        );
      case "poshmark":
        return (
          <img
            src={PoshmarkLogo}
            alt={"PlatformLogo"}
            className="platformLogo"
          />
        );
      case "depop":
        return (
          <img src={depopLogo} alt={"PlatformLogo"} className="platformLogo" />
        );
      case "shopify":
        return (
          <img
            src={ShopifyLogo}
            alt={"PlatformLogo"}
            className="platformLogo"
          />
        );
      case "StockX":
        return (
          <img src={stockxLogo} alt={"PlatformLogo"} className="platformLogo" />
        );
      case "mercari":
        return (
          <img
            src={MercariLogo}
            alt={"PlatformLogo"}
            className="platformLogo"
          />
        );
      case "goat":
        return (
          <img src={GOATLogo} alt={"PlatformLogo"} className="platformLogo" />
        );
      case "vinted":
        return (
          <img src={vintedLogo} alt={"PlatformLogo"} className="platformLogo" />
        );
      case "Grailed":
        return (
          <img
            src={Grailed}
            alt={"PlatformLogo"}
            className="platformLogo Grailed"
          />
        );
      case "OfferUp":
        return (
          <img
            src={offerupLogo}
            alt={"PlatformLogo"}
            className="platformLogo"
          />
        );
      case "instagram/facebook marketplace":
        return (
          <img
            src={FacebookLogo}
            alt={"PlatformLogo"}
            className="platformLogo"
          />
        );
      case "Custom":
      default:
        return type;
    }
  };

  const showTopPlatform = ({ className = "" }) => {
    return (
      <div className={className}>
        <div className="d-flex align-items-center justify-content-center">
          <h6
            className="green-text pt-3"
            onClick={() => setShowCompareList(!showCompareList)}
          >
            Compare expected profit on other platforms{" "}
            <span className="action-icon-clip" />
          </h6>
        </div>
        {showCompareList && (
          <div className="expected-wrapper">
            <div className="list-link pt-2">
              {data?.topThreeVal?.length > 0 &&
                data?.topThreeVal?.map((p: any, i) => (
                  <li key={i}>
                    <div className="provider-name">
                      <span>{i + 1}</span>
                      <div className="text">{renderPlatformLogo(p.name)}</div>
                    </div>
                    <div className="amount-text">${p.profit}</div>
                  </li>
                ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <CustomModal
      open={isCalculate}
      handleClose={() => setIsCalculate(false)}
      closeIcon={true}
      width={800}
      fixedCloseIcon
      background={isDarkMode ? "#101010" : "#fff"}
    >
      <div
        className={cs("d-flex align-items-center final-modal", {
          "dark-mode": isDarkMode,
        })}
      >
        <div
          className={cs("text-center p-4 pt-0  border-right-silver", {
            ["w-50"]: calculatorType === "calc-1",
          })}
        >
          {calculationSave === 2 ? (
            <>
              <h5 className="modal-title mb-2 mt-2">
                Your calculation has been saved!
              </h5>
            </>
          ) : (
            <>
              <h5 className="modal-title mb-4 mt-3">
                {isStep5
                  ? "Your profit margin is"
                  : "Profit Calculator for One Product"}
              </h5>
              <h6 className="modal-sub-title mb-1">
                {calculatorType === "calc-1" && (
                  <span>
                    Your profit for one product would be
                    <span className="font-bold"> $</span>
                    {data.profit}
                  </span>
                )}
                {calculatorType === "calc-2" &&
                  `You should list your product at $${data.listingPrice}`}
                {calculatorType === "calc-3" &&
                  `You should value your time at $${data.lcost} an hour `}
                {calculatorType === "calc-4" &&
                  `You earn an average of $${data.averagePerHour} an hour `}

                {isStep5 && (
                  <>
                    <span>Your profit margin is {data.netProfitMargin}%</span>
                    <br />
                    <span>Your net profit is ${data.netProfit}</span>
                  </>
                )}
              </h6>

              {calculatorType === "calc-1" &&
                showTopPlatform({ className: "mobile" })}

              <div className="d-flex w-100 align-items-center mt-4 justify-content-around">
                <CustomInput
                  formControlClass="time-input w-100"
                  className="w-100"
                  placeholder="Calculation name"
                  type="text"
                  name={"calcName"}
                  value={data.calcName}
                  onChange={({ target: { value, name } }) =>
                    setData({ ...data, [name]: value })
                  }
                  onBlur={handleBlur}
                  autoFocus
                />
              </div>
            </>
          )}

          <div className="mt-4 action-bottom-bar">
            {[0, 1].includes(calculationSave) && (
              <CustomButton
                contained
                size="large"
                secondary
                className="calculation-edit-button w-100 mt-3 font-weight-bold"
                onClick={handleSaveCalculation}
              >
                {calculationSave === 0 ? (
                  calcId ? (
                    "Update calculation"
                  ) : (
                    "Save calculation"
                  )
                ) : (
                  <CircularProgress size={25} />
                )}
              </CustomButton>
            )}
            {calculationSave !== 2 && (
              <CustomButton
                contained
                size="large"
                onClick={() => {
                  setIsCalculate(false);
                }}
                className="save-modal-btn w-100 mt-3 font-weight-bold"
              >
                Okay
              </CustomButton>
            )}

            {calculationSave === 2 && (
              <>
                <CustomButton
                  contained
                  size="large"
                  secondary
                  onClick={() => {
                    history.push(
                      `${location.pathname}?id=${saveCalculatorData.data._id}`
                    );
                    setIsCalculate(false);
                  }}
                  className="calculation-edit-button w-100 mt-3 font-weight-bold"
                >
                  Edit
                </CustomButton>
                <CustomButton
                  contained
                  size="large"
                  className={cs("save-modal-btn w-100 mt-3 font-weight-bold")}
                  style={{ width: "auto" }}
                  onClick={() => {
                    if (width < 600) {
                      dispatch(showMobileHeaderModal(true));
                      return;
                    }
                    sessionStorage.setItem("option", "saved");
                    handlePageBack();
                  }}
                >
                  View calculations
                </CustomButton>
              </>
            )}
          </div>
        </div>

        <div className="w-50">
          {calculatorType === "calc-1" &&
            showTopPlatform({ className: "desktop" })}
        </div>
      </div>
    </CustomModal>
  );
};

export default CalculationSavedModal;
